import React, { createContext, useContext } from "react";

export const FeaturesContext = createContext(
  {} as { features: Record<Feature, boolean> },
);

export const FeaturesProvider = ({ children, features }) => {
  return (
    <FeaturesContext.Provider value={{ features }}>
      {children}
    </FeaturesContext.Provider>
  );
};

export const useFeatures = () => {
  return useContext(FeaturesContext);
};

export enum Feature {
  SHOW_PETITION_MODELS = "show_petition_models",
  SHOW_DARK_MODE_TOGGLE = "show_dark_mode_toggle",
  SHOW_CREATE_REUSABLE_DIAGNOSIS_LINK_CREATION = "show_create_reusable_diagnosis_link_creation",
}
